<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <h3 class="mb-0">Notes</h3>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      empty-text="No Credit Notes"
      :data="notes"
    >
      <el-table-column
        label="Credit Note"
        min-width="120px"
        prop="email"
        sortable
      >
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <a :href="row.invoice_url" target="_blank">
                <span class="font-weight-600 mb-0 text-sm"> {{ row.id }}</span>
              </a>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Affiliate"
        min-width="190px"
        prop="event_type"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <router-link
              :to="{
                name: 'Affiliate Details',
                params: { id: row.affiliate.id }
              }"
            >
              <span class="mb-0 text-sm">{{ row.affiliate.email }}</span>
            </router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Created"
        min-width="190px"
        prop="createdAt"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm">{{
              new Date(row.createdAt).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                timeZone: 'UTC'
              })
            }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="190px" prop="status" sortable>
        <template v-slot="{ row }">
          <div class="align-items-center">
            <badge class="badge-dot mr-4" type="">
              <i
                :class="`bg-${
                  row.status === 'paid'
                    ? 'success'
                    : row.status === 'deleted'
                    ? 'default'
                    : 'danger'
                }`"
              ></i>
              <span class="status">{{
                row.status === 'paid'
                  ? 'Paid'
                  : row.status === 'deleted'
                  ? 'Deleted'
                  : 'Outstanding'
              }}</span>
            </badge>
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="80px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <button
              class="btn btn-sm btn-icon-only"
              :disabled="row.status === 'deleted'"
            >
              <i class="fas fa-ellipsis-v mt-2"></i>
            </button>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" href="#" @click="$emit('toggle', row)">{{
                row.status === 'paid' ? 'Mark Outstanding' : 'Mark Paid'
              }}</a>
              <a class="dropdown-item" href="#" @click="$emit('remove', row)"
                >Remove</a
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from 'element-ui'

export default {
  name: 'NotesTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    notes: Array
  }
}
</script>

<style scoped></style>
